import { ValidationErrors } from '@angular/forms';
import {
  SMEDisciplinePeerPoolViewModel,
  SMEDisciplineConfigViewModel,
} from '../../models/autogenerated';

export const codeRepeatedValidator = 'codeInUse';
export const codeRepeatedErrorMessage = 'The abbreviation is already in use';

export const CodeRepeatedValidator = (
  input: string | null,
  peerPool:
    | SMEDisciplinePeerPoolViewModel[]
    | SMEDisciplineConfigViewModel[]
    | null
): ValidationErrors => {
  const errors: ValidationErrors = {};
  if (
    input != null &&
    peerPool?.some(
      (peer) =>
        (peer as SMEDisciplinePeerPoolViewModel).disciplineCode === input ||
        (peer as SMEDisciplineConfigViewModel).code === input
    )
  ) {
    errors[codeRepeatedValidator] = codeRepeatedErrorMessage;
  }
  return errors;
};
